import { Injector } from '@angular/core';
import { Injectable, InjectionToken } from '@angular/core';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class DebugService {
    isDebug = false;
    
    private destroy$ = new Subject();
    private debugSub: Subscription = null;

    constructor() {
    }

    destroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private writeMessage( type: 'log' | 'warn' | 'error' | 'info', ...msg: any) {
        if (this.isDebug) {
            console[type](...msg);
        }
    }

    log(...msg: any) {
        this.writeMessage('log', msg);
    }

    warn(...msg: any) {
        this.writeMessage('warn', msg);
    }

    error(...msg: any) {
        this.writeMessage('error', msg);
    }

    info(...msg: any) {
        this.writeMessage('info', msg);
    }

    useDebugMode() {
        if (!this.debugSub) {
            this.debugSub = fromEvent(document.body, 'keydown').pipe(
                takeUntil(this.destroy$)
            ).subscribe( (e: KeyboardEvent) => {
                if (e.ctrlKey && e.shiftKey && e.key === 'D') {
                    e.preventDefault();
                    e.stopPropagation();
                    this.isDebug = !this.isDebug;
                    // console.log(`%cðª² Farris debug mode is ${ this.isDebug ? 'startting' : 'stopped'}.ðª²`, 'color: blue; font-weight:bold;font-size:16px')
                    console.log(`%cðª² Farris debug mode is ${  this.isDebug ? 'startting' : 'stopped'}.ðª²`, `color: ${  this.isDebug? 'green': 'red' }; font-weight:bold;font-size:16px`)
                }
            });
        }

        return this.debugSub;
    }
}
